import _ from 'lodash';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogComponentContext } from './contexts';

Cancel.propTypes = {
  children: PropTypes.node,
};
function Cancel({ children }) {
  const { t } = useTranslation();
  const { onClose } = useContext(DialogComponentContext);

  return (
    <button type="button" className="lw_btn_40" onClick={onClose}>
      {_.isEmpty(children) ? t('button_cancel') : children}
    </button>
  );
}

Action.propTypes = {
  className: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  children: PropTypes.node,
};
function Action({ className = 'lw_btn_point_40', onSelect, children }) {
  const { t } = useTranslation();
  const { onClose } = useContext(DialogComponentContext);
  const handleClick = () => onSelect(onClose);

  return (
    <button type="button" className={className} onClick={handleClick}>
      {_.isEmpty(children) ? t('button_confirm') : children}
    </button>
  );
}

export default {
  Cancel,
  Action,
};
